module.exports = __webpack_public_path__ + "img/gas5.3db62a62.png";